import React from "react";
import "../../styles/update/service.css";
export default function Services({ setServicesRef }) {
  const serviceRef = React.useRef(null);

  React.useEffect(() => {
    // Pass the ref up to Main
    if (setServicesRef) setServicesRef(serviceRef);
  }, [setServicesRef]);
  return (
    <div className="service" ref={serviceRef}>
      <p className="section-heading">Services</p>
      <div className="first-row">
        <div className="skill">
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="circle">
              <span className="material-icons-outlined">desktop_mac</span>
            </div>
            <p className="sub-heading">WEBSITE DEVELOPMENT</p>
          </div>
          <div>
            <p className="description">
              I specialize in creating responsive and user-friendly websites
              tailored to your needs. From dynamic single-page applications to
              robust e-commerce platforms, I ensure seamless functionality and
              stunning design. My services include custom web development, API
              integration, CMS setup, and optimization for performance and SEO.
              I also offer ongoing maintenance to keep your site secure and
              up-to-date. Let's build a professional online presence that stands
              out!
            </p>
          </div>
        </div>
        <div className="skill">
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="circle">
              <span className="material-icons-outlined">phone_android</span>
            </div>

            <p className="sub-heading">MOBILE APP</p>
          </div>
          <div>
            <p className="description">
              I craft high-performing, user-centric mobile applications for both
              Android and iOS platforms. Whether it's a sleek single-purpose app
              or a complex multi-feature solution, I ensure seamless performance
              and intuitive design. My services include cross-platform app
              development, API integration, app store deployment, and ongoing
              updates. From concept to launch, I handle every step with
              precision. Let’s create a mobile app that elevates your brand!
            </p>
          </div>
        </div>
      </div>

      <div className="second">
        <div className="skill">
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="circle">
              <span className="material-icons-outlined">smart_toy</span>
            </div>
            <p className="sub-heading">AI AND ML</p>
          </div>
          <div>
            <p className="description">
              I deliver cutting-edge AI and machine learning solutions tailored
              to your business needs. From predictive analytics and custom model
              development to computer vision and natural language processing, I
              leverage AI to solve complex challenges. My services include
              building and deploying ML models, data preprocessing, and
              integrating AI into existing systems. With expertise in
              TensorFlow, Python, and OpenCV, I transform your data into
              actionable insights. Let’s unlock the power of AI for your
              success!
            </p>
          </div>
        </div>
        <div className="skill">
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="circle">
              <span className="material-icons-outlined">
                motion_photos_auto
              </span>
            </div>
            <p className="sub-heading">INTERNET OF THINGS(IOT)</p>
          </div>
          <div>
            <p className="description">
              I provide end-to-end IoT solutions that connect devices,
              streamline processes, and deliver actionable insights. My services
              include IoT application development, sensor integration, real-time
              data collection, and analytics. From smart home automation to
              industrial IoT systems, I design secure and scalable solutions
              tailored to your needs. With expertise in IoT platforms and
              protocols, I help businesses unlock the full potential of
              connected technology. Let’s innovate together with IoT!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
